export default "__VITE_ASSET__D6D9VNcK__"